<script setup lang="ts">
import {Video} from "@/video/interfaces";
import VideoBox from "@/core/components/icons/VideoBox.vue";
import {HTMLAttributes} from "vue";
import {cn} from "@/lib/utils";
import EmbedVideoModalButton from "@/video/components/EmbedVideoModalButton.vue";

const props = defineProps<{
    video: Video;
    class?: HTMLAttributes['class']
}>();
</script>

<template>
  <EmbedVideoModalButton
    :title="video.title"
    :embed-video-url="video.url"
  >
    <div :class="cn('bg-white flex items-center gap-2 pr-2 rounded-lg', props.class)">
      <slot name="icon">
        <div class="rounded-md overflow-hidden">
          <VideoBox :size="30" />
        </div>
      </slot>
      <p class="video-title text-gray-600">
        {{ video.title }}
      </p>
    </div>
  </EmbedVideoModalButton>
</template>
